import * as React from "react";
const SvgRadioCheckedDisabled = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#FAFAFA"
      d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
    />
    <path
      fill="#EAEAEA"
      fillRule="evenodd"
      d="M12 21.7c5.357 0 9.7-4.343 9.7-9.7S17.357 2.3 12 2.3 2.3 6.643 2.3 12s4.343 9.7 9.7 9.7m0 1.3c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11"
      clipRule="evenodd"
    />
    <path fill="#EAEAEA" d="M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0" />
  </svg>
);
export default SvgRadioCheckedDisabled;
